import { mountPaymentWidget } from './components/payment-widget';
import { initializeLogs } from './core/logs';
import { PaymentError } from './core/payment-error';
import { CustomerFields, PaymentButtonState, PaymentConfig } from './types';

export { PaymentError } from './core/payment-error';
export type { PaymentErrorCode } from './core/payment-error';

export interface PaymentWidgetInstance {
    destroy: () => void;
    submitPayment: () => Promise<void>;
    getPaymentState: () => PaymentButtonState;
    updateCustomerFields: (fields: CustomerFields) => void;
}

function resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
        const element = document.getElementById(container);
        if (!element) {
            throw new PaymentError(
                `Container element "${container}" not found`,
                'VALIDATION_ERROR'
            );
        }
        return element;
    }

    return container;
}

export function init(config: PaymentConfig): PaymentWidgetInstance {
    initializeLogs(config.environment);
    const containerElement = resolveContainer(config.container);
    const reactInstance = mountPaymentWidget(containerElement, config);

    return {
        destroy: () => {
            reactInstance.destroy();
        },
        submitPayment: async () => {
            const api = reactInstance.getAPI();
            if (!api) {
                throw new PaymentError(
                    'Widget API not ready',
                    'VALIDATION_ERROR'
                );
            }
            await api.submitPayment();
        },
        getPaymentState: () => {
            const api = reactInstance.getAPI();
            if (!api) {
                return {
                    isProcessing: false,
                    canSubmit: false,
                    paymentComplete: false
                };
            }
            return api.getPaymentState();
        },
        updateCustomerFields: (fields: CustomerFields) => {
            const api = reactInstance.getAPI();
            if (!api) {
                throw new PaymentError(
                    'Widget API not ready',
                    'VALIDATION_ERROR'
                );
            }
            api.updateCustomerFields(fields);
        }
    };
}

export default {
    init
};
